import { Injectable } from '@angular/core';
const lookup = require('country-code-lookup');
const isEuMember = require("is-eu-member");

@Injectable({
    providedIn: 'root',
})
export class CountryHelperService {

    constructor() { }

    private _countries: any[];
    private _countryNames: any[];
    get countries(): any[] {
        if (!this._countries) {
            this.countries = this.getCountries();
        }
        return this._countries;
    }

    set countries(value: any[]) {
        this._countries = value;
    }
    get countryNames(): any[] {
        if (!this._countryNames) {
            this.countryNames = this.getCountryNames();
        }
        return this._countryNames;
    }

    set countryNames(value: any[]) {
        this._countryNames = value;
    }
    getCountries(): any[] {
        return lookup.countries;
    }
    getCountryNames(): any[] {
        let tmp = [];
        let items = this.getCountries();
        for (let i = 0; i < items.length; ++i) {
            let item = items[i];
            tmp.push({
                label: item.country,
                value: item.country
            });
        }
        return tmp;
    }
    private _countriesEU: any[];
    get countriesEU(): any[] {
        if (!this._countriesEU) {
            this.countries = this.getEUCountries();
        }
        return this._countriesEU;
    }

    set countriesEU(value: any[]) {
        this._countriesEU = value;
    }

    getEUCountries(): string[] {
        return isEuMember.getEuMembers();
    }

    isEUCountry(country: string): boolean {
        return isEuMember.isEuMember(country);
    }

    getCountryCodeByName(countryName: string): string {
        return lookup.byCountry(countryName);
    }

}
